// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"V3-z","colorTextValue":"W3-z","swatches":"X3-z","collapseLink":"Y3-z","isCollapsed":"Z3-z","dropdown":"_3-z","disabled":"a4-z"};